// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { relativeFixtureDate } from "../../../utils/zod";
import {
  RawResidentCommon,
  residentCommonSchema,
} from "../residentCommonSchema";
import {
  RawWorkflowsResidentRecord,
  workflowsResidentRecordSchema,
} from "../workflowsResidentRecordSchema";
import { usAzResidentMetadataFixtures } from "./metadata/fixtures";

export const rawUsAzResidentCommon: Array<RawResidentCommon> = [
  {
    stateCode: "US_AZ",
    personExternalId: "RES001",
    pseudonymizedId: "anonres001",
    displayId: "RES001",
    personName: {
      givenNames: "Elinor",
      middleNames: "Maja",
      surname: "Sloan",
    },
    facilityId: "FACILITY1",
    officerId: "OFFICER1",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES002",
    pseudonymizedId: "anonres002",
    displayId: "RES002",
    personName: {
      givenNames: "Michael",
      middleNames: "James",
      surname: "Mooney",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER2",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES003",
    pseudonymizedId: "anonres003",
    displayId: "RES003",
    personName: {
      givenNames: "Sebastien",
      middleNames: "Harry",
      surname: "Bose",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER3",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES004",
    pseudonymizedId: "anonres004",
    displayId: "RES004",
    personName: {
      givenNames: "Sasha",
      middleNames: "Gideon",
      surname: "Burch",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER3",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES014",
    pseudonymizedId: "anonres014",
    displayId: "RES014",
    personName: {
      givenNames: "Carl",
      middleNames: "Benedict",
      surname: "Garrett",
    },
    facilityId: "FACILITY1",
    officerId: "OFFICER1",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES015",
    pseudonymizedId: "anonres015",
    displayId: "RES015",
    personName: {
      givenNames: "Rosalie",
      middleNames: "Lana",
      surname: "Bloggs",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER1",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES016",
    pseudonymizedId: "anonres016",
    displayId: "RES016",
    personName: {
      givenNames: "Kyron",
      middleNames: "Daneel",
      surname: "Christensen",
    },
    facilityId: "FACILITY3",
    officerId: "OFFICER2",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES017",
    pseudonymizedId: "anonres017",
    displayId: "RES017",
    personName: {
      givenNames: "Teddy",
      middleNames: "Roger",
      surname: "Villegas",
    },
    facilityId: "FACILITY1",
    officerId: "OFFICER2",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES018",
    pseudonymizedId: "anonres018",
    displayId: "RES018",
    personName: {
      givenNames: "Derrell",
      middleNames: "Jason",
      surname: "Stewart",
    },
    facilityId: "FACILITY1",
    officerId: "OFFICER3",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES019",
    pseudonymizedId: "anonres019",
    displayId: "RES019",
    personName: {
      givenNames: "Allyn",
      middleNames: "Bobby",
      surname: "Fisher",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER3",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES020",
    pseudonymizedId: "anonres020",
    displayId: "RES020",
    personName: {
      givenNames: "Hailee",
      middleNames: "Gabriella",
      surname: "Esposito",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER3",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES021",
    pseudonymizedId: "anonres021",
    displayId: "RES021",
    personName: {
      givenNames: "Marcus",
      middleNames: "Theodore",
      surname: "Rivera",
    },
    facilityId: "FACILITY1",
    officerId: "OFFICER1",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES022",
    pseudonymizedId: "anonres022",
    displayId: "RES022",
    personName: {
      givenNames: "Sophia",
      middleNames: "Isabella",
      surname: "Chen",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER2",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES023",
    pseudonymizedId: "anonres023",
    displayId: "RES023",
    personName: {
      givenNames: "Darius",
      middleNames: "Alexander",
      surname: "Washington",
    },
    facilityId: "FACILITY3",
    officerId: "OFFICER3",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES024",
    pseudonymizedId: "anonres024",
    displayId: "RES024",
    personName: {
      givenNames: "Luna",
      middleNames: "Marie",
      surname: "Garcia",
    },
    facilityId: "FACILITY1",
    officerId: "OFFICER1",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES025",
    pseudonymizedId: "anonres025",
    displayId: "RES025",
    personName: {
      givenNames: "Kai",
      middleNames: "James",
      surname: "Nguyen",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER2",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES026",
    pseudonymizedId: "anonres026",
    displayId: "RES026",
    personName: {
      givenNames: "Aria",
      middleNames: "Sophia",
      surname: "Patel",
    },
    facilityId: "FACILITY3",
    officerId: "OFFICER3",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES027",
    pseudonymizedId: "anonres027",
    displayId: "RES027",
    personName: {
      givenNames: "Jordan",
      middleNames: "Avery",
      surname: "Sinclair",
    },
    facilityId: "FACILITY1",
    officerId: "OFFICER1",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES028",
    pseudonymizedId: "anonres028",
    displayId: "RES028",
    personName: {
      givenNames: "Layla",
      middleNames: "Jane",
      surname: "Okafor",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER2",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES029",
    pseudonymizedId: "anonres029",
    displayId: "RES029",
    personName: {
      givenNames: "Miles",
      middleNames: "Devon",
      surname: "Carter",
    },
    facilityId: "FACILITY3",
    officerId: "OFFICER3",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES030",
    pseudonymizedId: "anonres030",
    displayId: "RES030",
    personName: {
      givenNames: "Nadia",
      middleNames: "Ren",
      surname: "Hoffman",
    },
    facilityId: "FACILITY1",
    officerId: "OFFICER1",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES031",
    pseudonymizedId: "anonres031",
    displayId: "RES031",
    personName: {
      givenNames: "Owen",
      middleNames: "Blake",
      surname: "Santos",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER2",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES032",
    pseudonymizedId: "anonres032",
    displayId: "RES032",
    personName: {
      givenNames: "Priya",
      middleNames: "Kim",
      surname: "Wolfe",
    },
    facilityId: "FACILITY3",
    officerId: "OFFICER3",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES033",
    pseudonymizedId: "anonres033",
    displayId: "RES033",
    personName: {
      givenNames: "Quinn",
      middleNames: "Ellis",
      surname: "Torres",
    },
    facilityId: "FACILITY1",
    officerId: "OFFICER1",
  },
  {
    stateCode: "US_AZ",
    personExternalId: "RES034",
    pseudonymizedId: "anonres034",
    displayId: "RES034",
    personName: {
      givenNames: "Dani",
      middleNames: "Reed",
      surname: "Marsh",
    },
    facilityId: "FACILITY2",
    officerId: "OFFICER2",
  },
];

export const usAzResidentCommon = rawUsAzResidentCommon.map((r) =>
  residentCommonSchema.parse(r),
);

export const rawUsAzResidents: Array<RawWorkflowsResidentRecord> = [
  {
    ...rawUsAzResidentCommon[0],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res001",
    gender: "FEMALE",
    unitId: "UNIT A",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -3, days: -1 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[0],
  },
  {
    ...rawUsAzResidentCommon[1],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res002",
    gender: "MALE",
    unitId: "UNIT A",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -4, months: -4, days: -10 }),
    releaseDate: relativeFixtureDate({ days: 518 }),
    metadata: usAzResidentMetadataFixtures[1],
  },
  {
    ...rawUsAzResidentCommon[2],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res003",
    gender: "MALE",
    unitId: "UNIT B",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -3, months: -6, days: -18 }),
    releaseDate: relativeFixtureDate({ days: 442 }),
    metadata: usAzResidentMetadataFixtures[2],
  },
  {
    ...rawUsAzResidentCommon[3],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res004",
    gender: "MALE",
    unitId: "UNIT B",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ months: -11 }),
    releaseDate: relativeFixtureDate({ months: 20 }),
    metadata: usAzResidentMetadataFixtures[3],
  },
  {
    ...rawUsAzResidentCommon[4],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res014",
    gender: "MALE",
    unitId: "UNIT B",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -3, days: -1 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[4],
  },
  {
    ...rawUsAzResidentCommon[5],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res015",
    gender: "FEMALE",
    unitId: "UNIT C",
    custodyLevel: "MEDIUM",
    admissionDate: relativeFixtureDate({ years: -4, months: -4, days: -10 }),
    releaseDate: relativeFixtureDate({ days: 518 }),
    metadata: usAzResidentMetadataFixtures[5],
  },
  {
    ...rawUsAzResidentCommon[6],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res016",
    gender: "MALE",
    unitId: "UNIT A",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -3, months: -6, days: -18 }),
    releaseDate: relativeFixtureDate({ days: 442 }),
    metadata: usAzResidentMetadataFixtures[6],
  },
  {
    ...rawUsAzResidentCommon[7],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res017",
    gender: "MALE",
    unitId: "UNIT A",
    custodyLevel: "MEDIUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -2, days: -3 }),
    releaseDate: relativeFixtureDate({ days: 442 }),
    metadata: usAzResidentMetadataFixtures[7],
  },
  {
    ...rawUsAzResidentCommon[8],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res018",
    gender: "MALE",
    unitId: "UNIT B",
    custodyLevel: "MEDIUM",
    admissionDate: relativeFixtureDate({ months: -11 }),
    releaseDate: relativeFixtureDate({ months: 20 }),
    metadata: usAzResidentMetadataFixtures[8],
  },
  {
    ...rawUsAzResidentCommon[9],
    allEligibleOpportunities: [],
    stateCode: "US_AZ",
    recordId: "us_az_res019",
    gender: "MALE",
    unitId: "UNIT A",
    custodyLevel: "MEDIUM",
    admissionDate: relativeFixtureDate({ years: -1, days: -5 }),
    releaseDate: relativeFixtureDate({ months: 11, days: 25 }),
    metadata: usAzResidentMetadataFixtures[9],
  },
  {
    ...rawUsAzResidentCommon[10],
    allEligibleOpportunities: [],
    stateCode: "US_AZ",
    recordId: "us_az_res020",
    gender: "FEMALE",
    unitId: "UNIT A",
    custodyLevel: "MEDIUM",
    admissionDate: relativeFixtureDate({ years: -2, months: -4, days: -21 }),
    releaseDate: relativeFixtureDate({ months: 7, days: 9 }),
    metadata: usAzResidentMetadataFixtures[10],
  },
  {
    ...rawUsAzResidentCommon[11],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res021",
    gender: "MALE",
    unitId: "UNIT C",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -2 }),
    releaseDate: relativeFixtureDate({ months: 8 }),
    metadata: usAzResidentMetadataFixtures[11],
  },
  {
    ...rawUsAzResidentCommon[12],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res022",
    gender: "FEMALE",
    unitId: "UNIT B",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -3, months: -1 }),
    releaseDate: relativeFixtureDate({ months: 11 }),
    metadata: usAzResidentMetadataFixtures[12],
  },
  {
    ...rawUsAzResidentCommon[13],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res023",
    gender: "MALE",
    unitId: "UNIT A",
    custodyLevel: "MEDIUM",
    admissionDate: relativeFixtureDate({ years: -2, months: -3 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[13],
  },
  {
    ...rawUsAzResidentCommon[14],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res024",
    gender: "FEMALE",
    unitId: "UNIT B",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -6 }),
    releaseDate: relativeFixtureDate({ months: 6 }),
    metadata: usAzResidentMetadataFixtures[14],
  },
  {
    ...rawUsAzResidentCommon[15],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res025",
    gender: "MALE",
    unitId: "UNIT C",
    custodyLevel: "MEDIUM",
    admissionDate: relativeFixtureDate({ years: -2, months: -5 }),
    releaseDate: relativeFixtureDate({ months: 7 }),
    metadata: usAzResidentMetadataFixtures[15],
  },
  {
    ...rawUsAzResidentCommon[16],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res026",
    gender: "FEMALE",
    unitId: "UNIT B",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -4 }),
    releaseDate: relativeFixtureDate({ months: 8 }),
    metadata: usAzResidentMetadataFixtures[16],
  },
  {
    ...rawUsAzResidentCommon[17],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res027",
    gender: "MALE",
    unitId: "UNIT A",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -2, months: -3 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[17],
  },
  {
    ...rawUsAzResidentCommon[18],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res028",
    gender: "FEMALE",
    unitId: "UNIT B",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -6 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[18],
  },
  {
    ...rawUsAzResidentCommon[19],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res029",
    gender: "MALE",
    unitId: "UNIT A",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -4 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[19],
  },
  {
    ...rawUsAzResidentCommon[20],
    allEligibleOpportunities: ["usAzReleaseToTPR"],
    stateCode: "US_AZ",
    recordId: "us_az_res030",
    gender: "FEMALE",
    unitId: "UNIT B",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -2, months: -1 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[20],
  },
  {
    ...rawUsAzResidentCommon[21],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res031",
    gender: "MALE",
    unitId: "UNIT C",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -2, months: -5 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[21],
  },
  {
    ...rawUsAzResidentCommon[22],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res032",
    gender: "FEMALE",
    unitId: "UNIT B",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -9 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[22],
  },
  {
    ...rawUsAzResidentCommon[23],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res033",
    gender: "MALE",
    unitId: "UNIT C",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -8 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[23],
  },
  {
    ...rawUsAzResidentCommon[24],
    allEligibleOpportunities: ["usAzReleaseToDTP"],
    stateCode: "US_AZ",
    recordId: "us_az_res034",
    gender: "FEMALE",
    unitId: "UNIT A",
    custodyLevel: "MINIMUM",
    admissionDate: relativeFixtureDate({ years: -1, months: -7 }),
    releaseDate: relativeFixtureDate({ months: 9 }),
    metadata: usAzResidentMetadataFixtures[24],
  },
];

export const usAzResidents = rawUsAzResidents.map((r) =>
  workflowsResidentRecordSchema.parse(r),
);
